import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as S from './CatalogNavigator.styled'
import Link from 'next/link'
import { useList } from 'effector-react'
import { $generalGroups } from '@entities/groups/model'
import { useChildrenGroups } from '@entities/groups/hooks'

const ChildSelectedGroups = ({ children, ...props }) => {
    const childGroups = useChildrenGroups(children)
    return (
        <S.GroupContainer>
            {childGroups.map((childGroup) => (
                <Link href={`/catalog/${children}/${childGroup.id}`} key={childGroup.id} passHref legacyBehavior>
                    <S.GroupTitle {...props} data-catalog-id={childGroup.id} key={childGroup.id}>
                        {childGroup.title}
                    </S.GroupTitle>
                </Link>
            ))}
        </S.GroupContainer>
    )
}

const CatalogNavigator = (props) => {
    // first selected group
    const [selectedGeneralId, setSelectedGeneralId] = useState(344)

    const clickGeneral = (groupId) => (e) => {
        e.stopPropagation()
        setSelectedGeneralId(groupId)
    }

    const generals = useList($generalGroups, {
        keys: [selectedGeneralId],
        fn: (group) => (
            <S.GeneralGroupTitle
                onClick={clickGeneral(group.id)}
                isSelected={selectedGeneralId === group.id}
                data-general-catalog-id={selectedGeneralId}
                key={group.id}>
                {group.title}
            </S.GeneralGroupTitle>
        )
    })

    return (
        <S.AbsoluteContainer onClick={props.toggleShowedMenu}>
            <S.Container>
                <S.GeneralGroupsContainer>{generals}</S.GeneralGroupsContainer>
                <ChildSelectedGroups>{selectedGeneralId}</ChildSelectedGroups>
            </S.Container>
        </S.AbsoluteContainer>
    )
}

CatalogNavigator.propTypes = {
    toggleShowedMenu: PropTypes.func.isRequired
}

export default CatalogNavigator
